<template>
  <div class="bg-dark p-3">
    <router-link to="/about">关于</router-link>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
div {
  height: 20vh;
}
</style>